// extracted by mini-css-extract-plugin
var _1 = "message-card__BTj1n";
export { _1 as "messageCard" }
